import type { IconSvgObject } from './types';

const HtmlFile01Icon: IconSvgObject = [
  ["path", { d: "M5.5 17V19.5M5.5 19.5V22M5.5 19.5H2.5M2.5 17V19.5M2.5 19.5V22M9 17V22M9 17H7.5M9 17H10.5M12.5 22V17L14.5 19.5L16.5 17V22M19 17V22H21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3.5 13.9978L3.51994 3.99557C3.52238 2.89186 4.41845 1.99877 5.52216 2L12.4958 2.00776L19.5 8.99481L19.4922 13.9978M12.5 2.49778V6.99778C12.5 8.10235 13.3954 8.99778 14.5 8.99778H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default HtmlFile01Icon;
